import Loader from 'react-loaders'

import { useSelector } from 'react-redux'
import { useEffect, useRef, useState } from 'react'

import { Button } from 'reactstrap'
import { request } from '../../../Redux/Sagas/requests/api'

const RenewalEmailTemplatePreview = ({ data, onCancelPreview }) => {
  const [templatePreview, setTemplatePreview] = useState()
  const currentRow = useSelector((state) => state.CMS.currentRow)
  let uuid = currentRow?.[currentRow?.length - 1]?.uuid

  const [iframeHeight, setIframeHeight] = useState('0px')

  const iframeRef = useRef(null)
  const updateIframeHeight = () => {
    const iframe = iframeRef.current
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document
    setIframeHeight(`${iframeDoc.body.scrollHeight}px`)
  }

  useEffect(() => {
    let payload = {
      dynamic_email_title: data?.title,
      dynamic_message_to_client: data?.message,
    }
    request('renewal-locations/email-preview', 'POST', payload).then((res) => {
      
      if (res.data?.data?.emailTemplate) {
        setTemplatePreview(res.data?.data?.emailTemplate)
      }
    })
  }, [])
  useEffect(() => {
    if (iframeRef.current) {
      const iframeDoc = iframeRef.current.contentDocument
      iframeDoc.open()
      iframeDoc.write(templatePreview)
      iframeDoc.close()

      iframeRef.current.addEventListener('load', updateIframeHeight)
      updateIframeHeight()
    }
    return () => {
      if (iframeRef.current) {
        iframeRef.current.removeEventListener('load', updateIframeHeight)
      }
    }
  }, [templatePreview, iframeRef.current])

  return (
    <div>
      <div
        className='cursor-pointer mb-3'
        onClick={() => {
          onCancelPreview()
          // setIsPaymentRequestPreviewOpen(false)
        }}></div>
      <Button
        color='dark'
        className='mb-4'
        onClick={() => {
          onCancelPreview()
          // setIsPaymentRequestPreviewOpen(false)
        }}>
        {' '}
        <i class='fa-sharp fa-regular fa-arrow-left'></i>
      </Button>
      {templatePreview && <iframe ref={iframeRef} style={{ width: '100%', height: iframeHeight, border: 'none' }} title='HTML Renderer' />}

      {/* <div dangerouslySetInnerHTML={{ __html: html }}></div> */}
    </div>
  )
}

export default RenewalEmailTemplatePreview
